import { defineStyleConfig } from '@chakra-ui/react';

export const ChakraButton = defineStyleConfig({
  baseStyle: {
    fontWeight: 'bold',
    borderRadius: 'base'
  },
  sizes: {
    sm: {
      fontSize: 'sm',
      px: 4,
      py: 3
    },
    md: {
      fontSize: 'md',
      px: 6,
      py: 4
    }
  },
  variants: {
    outline: {
      border: '2px solid',
      borderColor: '#eab308',
      color: '#eab308',
      _hover: {
        transform: 'scale(1.05, 1.05)',
        bg: `#fef9c3`
      }
    },
    solid: {
      bg: '#eab308',
      color: 'white',
      _hover: {
        transform: 'scale(1.05, 1.05)',
        bg: `#facc15`
      }
    }
  },
  defaultProps: {
    size: 'md',
    variant: 'outline'
  }
});
